module.exports = __webpack_public_path__ + "assets/img/num-03-dfafdf1a.png";